import { z } from 'zod';
import { EstimateStatusSchema } from '../lib/enums';
import { zDateOnly, zIsoDateTime, zMoneyNonNeg, zPct, zUuid } from './common';
/** Dashboard aggregates — all money values derived server-side by the engine. */
export const PipelineStageSchema = z.object({
    status: EstimateStatusSchema,
    count: z.number().int().min(0),
    totalValue: zMoneyNonNeg,
});
export const DashboardPipelineResponseSchema = z.object({
    stages: z.array(PipelineStageSchema),
});
export const DashboardMetricsResponseSchema = z.object({
    /** Window the metrics cover, in days. */
    periodDays: z.number().int().min(1),
    sentCount: z.number().int().min(0),
    acceptedCount: z.number().int().min(0),
    declinedCount: z.number().int().min(0),
    /** accepted / (accepted + declined + expired); null when no decided estimates. */
    winRatePct: zPct.nullable(),
    /** Send → first view. */
    avgDaysToFirstView: z.number().finite().min(0).nullable(),
    /** Send → accept/decline. */
    avgDaysToDecision: z.number().finite().min(0).nullable(),
    totalAcceptedValue: zMoneyNonNeg,
    subTracking: z.object({
        openPackages: z.number().int().min(0),
        invitesAwaitingResponse: z.number().int().min(0),
        quotesAwaitingDecision: z.number().int().min(0),
        avgSubResponseDays: z.number().finite().min(0).nullable(),
    }),
});
export const DashboardAlertSchema = z.object({
    kind: z.enum([
        'license_expiring',
        'insurance_expiring',
        'proposal_expiring',
        'proposal_follow_up',
        'follow_up_due',
        'sub_quote_due',
        /** entityType 'warranty'; dueDate = expiresOn. See schemas/warranties.ts. */
        'warranty_expiring',
    ]),
    severity: z.enum(['info', 'warning', 'urgent']),
    message: z.string(),
    entityType: z.string().max(64),
    entityId: zUuid,
    dueDate: zDateOnly.nullable(),
    createdAt: zIsoDateTime.nullable(),
});
export const DashboardAlertsResponseSchema = z.object({
    alerts: z.array(DashboardAlertSchema),
});
//# sourceMappingURL=dashboard.js.map